// extracted by mini-css-extract-plugin
module.exports = {"titleGroup":"ob-module--titleGroup--uUWZL"};